import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/** 状态定义 */

const store = new Vuex.Store({
  state: {
    traceBack: false, // 可回溯开关-标识是否进行可回溯
    orderTabNum: '', // 订单tab记录
    userGender: '', // 当前用户性别
    allData: [],
    orderId: '',
    token: '',
    userInfo: {},
    status: '',
    orderIn: {},
    vehicleInfos: {},
    carOwnerInfo: {},
    applicantIn: {},
    recognizeeIn: {},
    baseInfo: {},
    itemKindList: {},
    profitDataList: {},
    calculateFlag: '',
    province: '',
    step: '',
    tab: '', // 记录从哪里点击进入
    show: true,
    insuredList: [],
    sumPremium: '0',
    InsurePolicy: {}, // 我的保单详情
    InsureId: '', // 我的保单:保单号
    InsureNum: '', // 我的保单:选中的num
    ClaimNum: '', // 我的理赔:选中的num
    ClaimDetail: {}, // 我的理赔详情
    ClaimId: '', // 我的理赔:报案号
    classCode: '', // 我的理赔:险类
    carShipTax: {},
    itemkindList: [],
    insuredFeeList: [],
    handlingFeeList: [],
    planList: [],
    carPolicySubInfoList: [],
    attachRiskList: [],
    itemFileDataList: [],
    engageList: [],
    engageLists: false,
    entrance: 0,
    transform: '0',
    schedule: '0',
    label: false,
    total: {},
    proposalAreaCode: '',
    proposalCityCode: '',
    steps: '',
    alter: 0, // 页面改变时改变
    alters: 0, // 页面改动时要跳转的页面
    variation: false, // 监听车型页与人员信息页是否有改动
    page: '1', // 等前第几页
    taxRelifInfo: '', // 暂存的车船税信息
    reviewQueList: [], // 回顾考题的数组
    phoneNumber: '', // 新用户注册保存手机号
    pages: 0, // 申请状态
    params: {}, // 一健续保查询到的信息
    marketVehicleDatas: {}, // 全民营销行驶证ocr数据
    terminalId: '', // 进入车险流程项目标记
    channelCode: '',
    userCode: '',
    introduceAgreementNo: '',
    userName: '',
    mark: false,
    applyPolicyInfo: {}, // 投保人信息
    insuredPolicyInfo: {}, // 被保险人信息
    policyChangeType: '', // 保单修改类型
    policyChangedName: '', // 保单修改姓名
    appToken: '',
    elecPolicy: [],
    productXInfoDTOList: [], // 选中产品列表
    initializeProductXInfoDTOList: [], // 初始化产品列表
    guohuFlag: false, // 报价之后过户车标志
    comCode: '',
    // 摩托车险
    motorPage: '',
    motorStep: '', // 步骤跳
    showStep: '', // 是否显示摩托车险步骤条
    motorOrderId: '',
    orderNo: '',
    motorBaseInfo: {}, // 摩托车险基础信息
    motorTaxRelifInfo: {}, // 摩托车险报价信息
    motormotorBaseInfo: {}, // 摩托车险报价提交核保的数据
    motorTraceBack: false, // 摩托车可回溯开关-标识是否进行可回溯
    motorOrderDetail: {}, // 摩托车订单详情
    motorComCode: '' // 行协摩托车增加X险获取机构代码
  },
  getters: {
    productXInfoDTOList: state => state.productXInfoDTOList,
    initializeProductXInfoDTOList: state => state.initializeProductXInfoDTOList,
    attachRiskList: state => state.attachRiskList,
    carPolicySubInfoList: state => state.carPolicySubInfoList
  },
  mutations: {
    set_productXInfoDTOList(state, value) {
      state.productXInfoDTOList = value
    },
    set_initializeProductXInfoDTOList(state, value) {
      state.initializeProductXInfoDTOList = value
    },
    elecPolicy(state, value) {
      state.elecPolicy = value
    },
    setMark(state, value) {
      state.mark = value
    },
    setUserName(state, value) {
      state.userName = value
    },
    setIntroduceAgreementNo(state, value) {
      state.introduceAgreementNo = value
    },
    setUserCode(state, value) {
      state.userCode = value
    },
    setChannelCode(state, value) {
      state.channelCode = value
    },
    setTerminalId(state, value) {
      state.terminalId = value
    },
    setMarketVehicleDatas(state, value) {
      state.marketVehicleDatas = value
    },
    setParams(state, value) {
      state.params = value
    },
    setPhoneNumber(state, value) {
      state.phoneNumber = value
    },
    setPages(state, value) {
      state.pages = value
    },
    reviewQueList(state, value) {
      state.reviewQueList = value
    },
    setTaxRelifInfo(state, value) {
      state.taxRelifInfo = value
    },
    setPage(state, value) {
      state.page = value
    },
    setVariation(state, value) {
      state.variation = value
    },
    setAlter(state, value) {
      state.alter += 1
      state.alters = value
    },
    emptyAlter(state) {
      state.alter = 0
    },
    setSteps(state, value) {
      state.steps = value
    },
    setProposalCityCode(state, value) {
      state.proposalCityCode = value
    },
    setProposalAreaCode(state, value) {
      state.proposalAreaCode = value
    },
    setOrderTabNum(state, value) {
      state.orderTabNum = value
    },
    setTotal(state, value) {
      state.total = value
    },
    setLabel(state, value) {
      state.label = value
    },
    setSchedule(state, value) {
      state.schedule = value
    },
    setTransform(state, value) {
      state.transform = value
    },
    setEntrance(state, value) {
      state.entrance = value
    },
    setEngageLists(state, value) {
      state.engageLists = value
    },
    setEngageList(state, value) {
      state.engageList = value
    },
    setItemFileDataList(state, value) {
      state.itemFileDataList = value
    },
    setCarPolicySubInfoList(state, value) {
      state.carPolicySubInfoList = value
    },
    set_attachRiskList(state, value) {
      state.attachRiskList = value
    },
    setPlanList(state, value) {
      state.planList = value
    },
    setHandlingFeeList(state, value) {
      state.handlingFeeList = value
    },
    setInsuredFeeList(state, value) {
      state.insuredFeeList = value
    },
    setItemkindList(state, value) {
      state.itemkindList = value
    },
    setCarShipTax(state, value) {
      state.carShipTax = value
    },
    setUserGender(state, value) {
      state.userGender = value
    },
    setSumPremium(state, value) {
      state.sumPremium = value
    },
    // 人员信息
    setInsuredList(state, value) {
      state.insuredList = value
    },
    // 报价页步骤条
    setStep(state, value) {
      state.step = value
    },
    // 1:从首页或产品页进入
    // 2:从首页行驶证报价处进入
    // 3:从订单进入，需获取openid查询订单详情回显
    // 4:从已出单进入
    setTab(state, value) {
      state.tab = value
    },
    setShow(state, value) {
      state.show = value
    },
    // 订单详情
    setOrderIn(state, value) {
      state.orderIn = value
    },
    // 车辆信息
    setVehicleInfo(state, value) {
      state.vehicleInfos = value
      // console.log(219,value);
    },
    // 车主信息
    setCarOwnerInfo(state, value) {
      state.carOwnerInfo = value
    },
    // 投保人信息
    setApplicantIn(state, value) {
      state.applicantIn = value
    },
    // 被保人信息
    setRecognizeeIn(state, value) {
      state.recognizeeIn = value
    },
    // baseInfo
    setBaseInfo(state, value) {
      state.baseInfo = value
    },
    // itemKindList
    setItemKindList(state, value) {
      state.itemKindList = value
    },
    // profitDataList
    setProfitDataList(state, value) {
      state.profitDataList = value
    },
    // 交强商业关联标识
    setCalculateFlag(state, value) {
      state.calculateFlag = value
    },
    // 投保地区
    setProvince(state, value) {
      state.province = value
    },
    // 数据字典数据
    setAllData(state, value) {
      state.allData = value
    },
    // 微信openid
    setOrderId(state, value) {
      state.orderId = value
      // console.log(260,value)
    },
    // 存token
    setToken(state, value) {
      state.token = value
    },
    // 存userInfo
    setUserInfo(state, value) {
      state.userInfo = value
    },
    // 是否认证的是状态
    setStatus(state, value) {
      state.status = value
    },
    // 我的保单详情
    setInsurePolicy(state, value) {
      state.InsurePolicy = value
    },
    // 我的保单:保单号
    setInsureId(state, value) {
      state.InsureId = value
    },
    // 我的理赔详情
    setClaimDetail(state, value) {
      state.ClaimDetail = value
    },
    // 我的理赔:报案号
    setClaimId(state, value) {
      state.ClaimId = value
    },
    // 我的理赔:险类
    setclassCode(state, value) {
      state.classCode = value
    },
    // 我的保单:选中的num
    setInsureNum(state, value) {
      state.InsureNum = value
    },
    // 我的理赔:选中的num
    setClaimNum(state, value) {
      state.ClaimNum = value
    },
    // 设置投保人信息
    setApplyPolicyInfo(state, value) {
      state.applyPolicyInfo = value
    },
    // 设置被保险人信息
    setInsuredPolicyInfo(state, value) {
      state.insuredPolicyInfo = value
    },
    // 设置保单变更类型
    policyChangeType(state, value) {
      state.policyChangeType = value
    },
    // 设置保单变更姓名
    policyChangedName(state, value) {
      state.policyChangedName = value
    },
    setAppToken(state, value) {
      state.appToken = value
    },
    setTraceBack(state, value) {
      state.traceBack = value
    },
    setGuohuFlag(state, value) {
      state.guohuFlag = value
    },
    setComCode(state, value) {
      state.comCode = value
    },
    set_motorPage(state, value) {
      state.motorPage = value
    },
    set_motorStep(state, value) {
      state.motorStep = value
    },
    set_showStep(state, value) {
      state.showStep = value
    },
    set_motorOrderId(state, value) {
      state.motorOrderId = value
    },
    set_orderNo(state, value) {
      state.orderNo = value
    },
    set_motorBaseInfo(state, value) {
      state.motorBaseInfo = value
    },
    set_motorTaxRelifInfo(state, value) {
      state.motorTaxRelifInfo = value
    },
    set_motormotorBaseInfo(state, value) {
      state.motormotorBaseInfo = value
    },
    setMotorTraceBack(state, value) {
      state.motorTraceBack = value
    },
    set_motorOrderDetail(state, value) {
      state.motorOrderDetail = value
    },
    set_motorComCode(state, value) {
      state.motorComCode = value
    }
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js